enum SectionType {
  STRAIGHT_PIPE_HORIZONTAL = "Horizontal Section",
  PIPE_BEND_HORIZONTAL = "Horizontal Bend Section",
  STRAIGHT_PIPE_VERTICAL = "Vertical Section",
  PIPE_BEND_VERTICAL = "Vertical Bend Section",
}

export default SectionType